import {
  InferInput,
  nonEmpty,
  object,
  pipe,
  string,
  trim,
  union,
} from "valibot";

export const authorSchema = union([
  object({
    registered: object({
      id: string(),
      displayName: string(),
    }),
  }),
  object({
    unregistered: object({
      fullName: pipe(string(), trim(), nonEmpty()),
    }),
  }),
]);

export type AuthorSchema = typeof authorSchema;
export type AuthorSchemaInput = InferInput<AuthorSchema>;

export const AuthorSchema = Object.freeze({
  eq(a: AuthorSchemaInput, b: AuthorSchemaInput): boolean {
    if ("registered" in a && "registered" in b) {
      return a.registered.id === b.registered.id;
    } else if ("unregistered" in a && "unregistered" in b) {
      return a.unregistered.fullName === b.unregistered.fullName;
    }
    return false;
  },
});
